import React, { Component } from 'react'
import classNames from 'classnames'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { compose } from 'redux'
import Icon from '@material-ui/core/Icon';
import { withSnackbar } from 'notistack';
import {
    toggleDropBox,
    editTitle,
    addTag,
    fetchTags,
    removeTag,
    editUserName,
    editUser,
    newUser,
    fetchUser,
    saveAuthUser,
    saveAuthUseList,
    removeAuthUseList,
    isSavedList,
    fetchAuthUseList
} from '../../actions'
import { TOGGLE_SETTING_SUCCESS } from '../../actionTypes'
import { watchTags, watchSavedLists, watchNotificationSavedList } from '../../actions/firebaseWatch'
import { getTags, getKeyTagByIndex } from '../../selectors'
import { setLocalStorageTitle } from '../../functions/snippets'
import Tag  from '../../components/Tag'

import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';
import { SocialIcon } from 'react-social-icons';
import firebase from 'firebase/app';
import database from "../../actions/database";
import NProgress from 'nprogress'
NProgress.configure({ showSpinner: true, easing: 'ease', speed: 500, minimum: 0.6 })



class Setting extends Component {
    constructor(props){
        super(props);

        this.state = {
            tagValue: '',
            isSavedList: false
        }

        this.handleChange = this.handleChange.bind(this)
        this.handleTagChange = this.handleTagChange.bind(this)
        this.handleTagSubmit = this.handleTagSubmit.bind(this)
        this.handleChangeUserName = this.handleChangeUserName.bind(this)
    }

    /*uiConfig = {
        // Popup signin flow rather than redirect flow.
        signInFlow: 'popup',
        // We will display Google and Facebook as auth providers.
        signInOptions: [
            firebase.auth.GoogleAuthProvider.PROVIDER_ID,
            firebase.auth.FacebookAuthProvider.PROVIDER_ID
        ],
        callbacks: {
            // Avoid redirects after sign-in.
            signInSuccessWithAuthResult: () => false
        }
    };*/


    componentDidMount() {

        const { id } = this.props.ownProps.params
        this.props.watchTags(id)
        this.props.fetchTags(id)
        this.fetchUserHandler(id)
    }

    fetchUserHandler = (id) => {
        this.props.fetchUser(id).then((newUser) => {
            this.unregisterAuthObserver = firebase.auth().onAuthStateChanged(
                (user) => {
                    this.setState({isSignedIn: !!user})
                    if(!user) return


                    this.props.fetchAuthUseList(user.uid).then(data => {
                        this.props.watchNotificationSavedList(this.props.savedLists, user.uid)
                    })
                    this.props.watchSavedLists(user.uid)
                    if(newUser){
                        const newUser = {...this.props.user}
                        newUser.oldUser = {...this.props.user}
                        newUser.name = user.displayName;
                        newUser.id = user.uid;
                        this.props.editUser(id, newUser)
                    }

                  /*  console.log(user)
                    const newUser = {...this.props.user}
                    newUser.oldUser = {...this.props.user}
                    newUser.name = user.displayName;
                    newUser.id = user.uid;
                    newUser.isAuth = true;
                    console.log(newUser)
                    this.props.editUser(id, newUser)*/

                    user && isSavedList(user.uid, id).then((con) => {
                        this.setState({
                            isSavedList: con
                        })
                    });
                }
            );

        })
    }

    componentWillReceiveProps(nextProps) {
        const id  = this.props.ownProps.params.id
        const nextId  = nextProps.ownProps.params.id
        const user  = nextProps.user

        if ((nextProps.savedLists !== this.props.savedLists) || (id !== nextId)) {
            this.props.user && isSavedList(nextProps.user.id, nextId).then((con) => {
                this.setState({
                    isSavedList: con
                })
            });

        }

        if (id !== nextId) {
            this.fetchUserHandler(nextId)
            this.props.watchTags(nextId)
            this.props.watchNotificationSavedList(nextProps.savedLists, user.id)
        }
    }

    componentWillUnmount() {
        this.unregisterAuthObserver();
    }

    handleChange (event){
        const { id } = this.props.ownProps.params
        const { editTitle } = this.props
        editTitle(id, event.target.value).then(() => {
            setLocalStorageTitle()
        })
    }

    handleChangeUserName (event){
        const { editUser, user } = this.props
        const { id } = this.props.ownProps.params
        const newUser = {...user}
        newUser.name = event.target.value;
        editUser(id, newUser)
    }

    handleTagChange (event){
        this.setState({
            tagValue: event.target.value
        })
    }

    handleTagSubmit (event){
        event.preventDefault()

        const { id } = this.props.ownProps.params
        const { addTag } = this.props
        const { tagValue } = this.state
        addTag(id, tagValue)
        this.setState({
            tagValue: ''
        })
    }

    handleSaveAuthUseList = () => {
        const { id } = this.props.ownProps.params
        const { user, enqueueSnackbar, title } = this.props
        NProgress.start()
        saveAuthUseList(user.id, id, title).then(() => {
            enqueueSnackbar('Лист сохранен');
            NProgress.done()
            this.setState({
                isSavedList: true
            })
        })
    }

    handleRemoveAuthUseList = () => {
        const { id } = this.props.ownProps.params
        const { user, enqueueSnackbar } = this.props
        NProgress.start()
        removeAuthUseList(user.id, id).then(() => {
            enqueueSnackbar('Лист удален');
            NProgress.done()
            this.setState({
                isSavedList: false
            })
        })
    }


    signInMy = (type) => {
        let socialProvider = {
            google: 'GoogleAuthProvider',
            facebook: 'FacebookAuthProvider'
        }
        var provider = new firebase.auth[socialProvider[type]]();

        firebase.auth().signInWithPopup(provider).then(async(result) => {
            const { id } = this.props.ownProps.params
            let snap =  await database.ref('/data/' + id + '/users/' +  result.user.uid).once("value");
            let { editUser, user } = this.props
            const newUser = {...user}
            newUser.oldUser = {...user}
            newUser.name = result.user.displayName;
            newUser.id = result.user.uid;
            let data = snap.val() ?  snap.val() : newUser

            editUser(id, data)
            saveAuthUser(data)

        }).catch(function(error) {
            // Handle Errors here.
            var errorCode = error.code;
            var errorMessage = error.message;
            // The email of the user's account used.
            var email = error.email;
            // The firebase.auth.AuthCredential type that was used.
            var credential = error.credential;
            // ...
            console.log(error)
        });
    }

    handleSignOut = () => {
        let { editUser, user } = this.props
        const { id } = this.props.ownProps.params
        firebase.auth().signOut().then(() => {
            editUser(id, user.oldUser)
        })
    }

    renderSaveBtn = () => {
        let template = !this.state.isSavedList ? (
            <a className='sign-out__btn' onClick={this.handleSaveAuthUseList}>
                <Icon> save </Icon>
            </a>
        ) : (
            <a className='sign-out__btn' onClick={this.handleRemoveAuthUseList}>
                <Icon> delete </Icon>
            </a>
        )

        return template
    }



    render() {

        const { dropBox, toggleDropBox, title, tags, removeTag, tagsIds, user } = this.props;
        const { id } = this.props.ownProps.params;
        const dropClass = classNames({
            'pop-full-box': true,
            'active': dropBox.setting
        });
        const handleDeleteTag = index => {
            const keyTags = getKeyTagByIndex(tagsIds,index)
            removeTag(id, keyTags)
        }


        return (
            <div className={dropClass}>
                <div className="pop-full-box__bg" onClick={() => toggleDropBox(TOGGLE_SETTING_SUCCESS)}></div>
                <div className="pop-full-box__wrap">
                    <div className="pop-block__header">
                        <div className="pop-block__head-wrap">
                            <div className="pop-block__head-icon">
                                <i className="icon-setting"></i>
                            </div>
                            <div className="pop-block__head-hint">
                                Settings
                            </div>
                        </div>
                        <div className="pop-full-box__close" onClick={() => toggleDropBox(TOGGLE_SETTING_SUCCESS)}>
                            <i className="icon-close"></i>
                        </div>
                    </div>
                    <div className="pop-block__content">
                        {
                            id && (
                                <div className="pop-block__content-row">
                                    <div className="pop-block__label">Project name</div>
                                    <div className="pop-block__field-wrap pop-block__field-wrap_user">
                                        <input
                                            onChange={this.handleChange}
                                            type="text"
                                            className="pop-block__field pop-block__field_light"
                                            value={title}
                                            autoFocus={true}
                                        />
                                        {
                                            this.state.isSignedIn && this.renderSaveBtn()
                                        }
                                    </div>
                                </div>
                            )
                        }



                        {
                            (this.state.isSignedIn || id) && (
                                <div className="pop-block__content-row">
                                    <div className="pop-block__label">User name</div>

                                    <div className="pop-block__field-wrap pop-block__field-wrap_user">
                                        <input
                                            onChange={this.handleChangeUserName}
                                            type="text"
                                            className="pop-block__field pop-block__field_light"
                                            value={user.name ? user.name : ''}
                                        />


                                        {
                                            this.state.isSignedIn && (
                                                <a className='sign-out__btn' onClick={this.handleSignOut}>
                                                    <Icon> cancel </Icon>
                                                </a>
                                            )
                                        }


                                    </div>
                                </div>
                            )
                        }




                        <div className='pop-block__content-row'>
                            {
                                !this.state.isSignedIn && (
                                    <div>
                                        <div className="pop-block__label">Auth</div>
                                        <div className="social__wrap">
                                            <div className='social__wrap-item' onClick={() => this.signInMy("google")}>
                                                <SocialIcon network="google"  />
                                            </div>
                                            <div className='social__wrap-item' onClick={() => this.signInMy("facebook")}>
                                                <SocialIcon network="facebook"  />
                                            </div>
                                        </div>

                                    </div>
                                )
                            }
                        </div>

                        {
                            id && (
                                <div className="pop-block__content-row">
                                    <div className="pop-block__label">Add tag</div>
                                    <div className="pop-block__field-wrap">
                                        <form action="" onSubmit={this.handleTagSubmit}>
                                            <input
                                                placeholder="Specify a name or position"
                                                type="text"
                                                className="pop-block__field pop-block__field_light"
                                                value={this.state.tagValue}
                                                onChange={this.handleTagChange}
                                            />
                                            <button type="submit" className="pop-block__field-icon-wrap color_blue">
                                                <i className="icon-plus"></i>
                                            </button>
                                        </form>
                                    </div>
                                    <div className="pop-block__tags">
                                        {
                                            tags && tags.map((tag, index) => {
                                                return(
                                                    <Tag
                                                        key={index}
                                                        index={index}
                                                        tag={tag}
                                                        handleDeleteTag={handleDeleteTag}
                                                        addTagToLine={()=>{}}
                                                    />
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            )
                        }




                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => ({
    dropBox: state.dropBox,
    title: state.title,
    tags: getTags(state),
    tagsIds: state.tagsIds,
    user: state.user,
    savedLists: state.savedLists,
    ownProps
})

const mapDispatchToProps = {
    toggleDropBox,
    editTitle,
    addTag,
    fetchTags,
    watchTags,
    removeTag,
    editUserName,
    editUser,
    newUser,
    fetchUser,
    fetchAuthUseList,
    fetchAuthUseList,
    watchSavedLists,
    watchNotificationSavedList
}

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(withSnackbar(Setting))


// WEBPACK FOOTER //
// ./src/containers/drop/Setting.js